<template>
  <div class="alert-message"
       v-if="infoMessage">
    <div class="info-alert">
      <span>
        <localized-label>infoMessage</localized-label>
      </span>
      <i class="n-i n-i-close info-icon"
         @click="setInfoMessage(false)">
      </i>
    </div>
    <div class="info-message">
      <span>{{infoMessage}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'InfoMessage',
  computed: {
    ...mapGetters([
      'infoMessage',
    ]),
  },
  mounted() {
    setTimeout(() => { this.setInfoMessage(null); }, 10000);
  },
  methods: {
    ...mapActions([
      'setInfoMessage',
    ]),
  },
};
</script>
<style lang="scss" scoped>
.alert-message {
  position: fixed;
  width: 300px;
  height: 100px;
  margin: 10px;
  padding: 20px;
  border-radius: 4px;
  background-color: #009aff;
  bottom: 0;
  color: #ffffff;
  .info-alert {
    display: flex;
    justify-content: space-between;
    > span {
      font-size: 18px;
      font-weight: 400;
    }
    .info-icon {
      cursor: pointer;
      &:hover {
        color: #535d63;
      }
    }
  }
  .info-message {
    padding-top: 8px;
  }
}
</style>
